export default "__VITE_ASSET__b05efc82__"